<div class="px-4 pb-3 pt-0 overflow-y-auto zuper-scrollbar bg-white organizaton-quick-create-form" *ngIf="organizationForm">
    <div class="">
        <form class="flex flex-wrap divide-y divide-gray-200" autocomplete="off" [formGroup]="organizationForm">
            <div class="flex flex-wrap w-full py-3" [ngClass]="header.isMatCheck ? 'justify-between' : ''"
                *ngFor="let header of createOrganization;let i=index">
                <label *ngIf="header.canShow"
                    class="text-gray-700 truncate font-bold text-base">{{header.headerDisplayKey
                    |
                    translate}}</label>
                <div class="flex justify-start items-center primary-font mr-2" *ngIf="header.canShow && header.isMatCheck">
                    <label for="{{header.headerName + '_org_check'}}" class="block text-base text-gray-700 mr-2 cursor-pointer">{{header.matCheckLabel |
                        translate}}</label>
                    <input id="{{header.headerName + '_org_check'}}" [formControlName]="header.formControlName" type="checkbox"
                     class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded">
                </div>
                <div class="flex w-full flex-wrap"
                    *ngIf="header.headerType !== 'address' && checkFieldsContainerVisibility(header)">
                    <div class="px-2 py-3" [ngClass]="field.cssClass ? field.cssClass : 'field-container-half-width'"
                        *ngFor="let field of header.formFields;let i=index">
                        <!-- Dropdown Field Type not clearable and multiple false -->
                        <div *ngIf="field.fieldType === 'dropdown' && field?.showIf">
                            <label class="block text-base font-medium text-gray-700">{{field.labelDisplayKey |
                                translate}}<span *ngIf="field.isMandatory" class="mandatory-field">*</span>
                            </label>
                            <ng-select class="w-full mt-1 border-l-0" placeholder="{{field.placeHolderDisplayKey | translate}}"
                                [formControlName]="field.formControlName" [clearable]="false"
                                [multiple]="false" [hideSelected]="true">
                                <ng-option *ngFor="let option of getObservable(field.fieldId) | async" [value]="option[field.oberservableValue]"><span
                                        title="{{option?.[field.oberservableValue]}}">{{option?.[field.oberservableKey]}}</span></ng-option>
                            </ng-select>
                        </div>
                        <!-- Basic Field Type -->
                        <div class="field-full-width quick-create-form-field" *ngIf="field.fieldType === 'input'">
                            <label for="{{field.fieldId}}" class="block text-base font-medium text-gray-700">{{field.labelDisplayKey |
                                translate}}<span *ngIf="field.isMandatory" class="mandatory-field">*</span>
                            </label>
                            <input id="{{field.fieldId}}" type="{{field.inputType}}" [formControlName]="field.formControlName"
                                class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                                placeholder="{{field.placeHolderDisplayKey | translate}}">
                            <p class="text-red-500 text-base mt-1 primary-font" *ngIf="showError(field.formControlName)">{{getErrorMessageKey(field)
                                |
                                translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="w-full" *ngIf="header.headerType === 'address'">
                    <contact-info [hidden]="!checkFieldsContainerVisibility(header)" [fields]="header.contactFields"
                        [addressFormGroupName]="header.formGroupName">
                    </contact-info>
                </div>
            </div>
        </form>
    </div>
</div>